import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { ConstantesService } from '../../services/constantes.service';
import { ConfiguracionPlanBean } from 'src/app/_beans/ConfiguracionPlanBean';
import { AuthService } from '../../services/auth.service';
import { CambiarClaveDialogComponent } from 'src/app/pages/cambiar-clave/cambiar-clave-dialog/cambiar-clave-dialog.component';
import { ObjetivoDialogComponent } from 'src/app/pages/objetivos/objetivo-dialog/objetivo-dialog.component';
import { MetaDialogComponent } from 'src/app/pages/meta/meta-dialog/meta-dialog.component';
import { ObjetivoBean } from 'src/app/_beans/ObjetivoBean';
import { MetaBean } from 'src/app/_beans/MetaBean';
import { AvanceDialogComponent } from 'src/app/pages/avance/avance-dialog/avance-dialog.component';
import { AvanceBean } from 'src/app/_beans/AvanceBean';
import { NavItem } from 'src/app/shared/components/nav-item';
import { Router } from '@angular/router';
import { RestProviderService } from '../../services/rest-provider.service';
import { UsuarioFormComponent } from 'src/app/pages/usuario/usuario-form/usuario-form.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  public navItems: NavItem[] = [];

  constructor(
    private restProvider: RestProviderService,
    private router: Router,
    public sharedService: SharedService,
    public constantes: ConstantesService,
    public dialog: MatDialog,
    public authService: AuthService) {
    this.sharedService.onMenuItemClick.subscribe(data => {
      if (data.link == 'AGREGAR_OBJETIVO') {
        this.abrirObjetivoDialog(data.object);
      }
      if (data.link == 'AGREGAR_AVANCE') {
        this.abrirAvanceDialog();
      }
    });
  }

  public cargarPlan() {
    let params = {
      data: {
        id: this.constantes.ID_CATALOGO_LIMITE_SEMAFORO
      }
    }
    this.restProvider.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
     let listaValoresSemaforo:any[]=result.datalist;
     this.sharedService.limiteRojo=listaValoresSemaforo[0].valorAuxiliar;
     this.sharedService.limiteAmbar=listaValoresSemaforo[1].valorAuxiliar;
        this.restProvider.executeHttpMethod("/pc/bpi", {data:{id:this.constantes.ID_PLAN_PNLOTI}}).subscribe((result: any) => {
          this.sharedService.planSession = result.data;
          let params2 = {
            data: {
              plan: {
                id: this.constantes.ID_PLAN_PNLOTI
              }
            }
          }
          this.restProvider.executeHttpMethod("/cpc/bpip", params2).subscribe((result: any) => {
            this.sharedService.planSession.listaConfiguracionPlan = result.datalist;
            if(!this.sharedService.userSession){
              this.sharedService.userSession={}
              this.sharedService.userSession.opciones=[
                {
                  "label": "Dashboard",
                  "code": "DASHBOARD",
                  "link": "/dashboard/lac",
                  "faIcon": "fab fa-microsoft",
                  "permissions": "VER"
                }
              ]
            }
          });
          sessionStorage.setItem('PLAN_SELECCIONADO', JSON.stringify(result.data));
          this.router.navigate(['dashboard/lac'], { skipLocationChange: true });

        });
    });
  }

  ngOnInit() {
    setTimeout(() => {
    if(!(this.sharedService.userSession)){
      this.cargarPlan();
    }
    let opciones: any[] = [];
    if(this.sharedService.userSession && this.sharedService.userSession.id){
      opciones = JSON.parse(this.sharedService.userSession.opciones);
      if (this.sharedService.planSession && this.sharedService.planSession.listaConfiguracionPlan && this.sharedService.planSession.listaConfiguracionPlan.length > 0) {
        let listaConfiguracionPlan: Array<ConfiguracionPlanBean> = this.sharedService.planSession.listaConfiguracionPlan;
        let descripcionPrimerNivel = listaConfiguracionPlan[0].nombre;
        let descripcionUltimoNivel = listaConfiguracionPlan[listaConfiguracionPlan.length - 1].nombre;
        this.cambiarLabelOpcion(opciones, this.constantes.DESCRIPCION_PRIMER_NIVEL_PLAN_SESION, descripcionPrimerNivel);
        this.cambiarLabelOpcion(opciones, this.constantes.DESCRIPCION_ULTIMO_NIVEL_PLAN_SESION, descripcionUltimoNivel);

        if (this.sharedService.userSession.perfil != this.constantes.TIPO_USUARIO_OPERADOR && this.sharedService.userSession.perfil != this.constantes.TIPO_USUARIO_ADMINISTRADOR) {
          this.sharedService.planSession.listaConfiguracionPlan.forEach(conf => {
            let navItem = {
              'faIcon': 'fas fa-plus-circle',
              'label': conf.nombre,
              'link': 'AGREGAR_OBJETIVO',
              'object': conf
            }
            this.agregarOpcion(opciones, this.constantes.OPCION_AGREGAR_REGISTRO, navItem);
          });
        }

        let navItem = {
          'faIcon': 'fas fa-plus-circle',
          'label': 'Avance',
          'link': 'AGREGAR_AVANCE'
        }
        this.agregarOpcion(opciones, this.constantes.OPCION_AGREGAR_REGISTRO, navItem);
        this.cambiarLabelOpcion(opciones, this.constantes.OPCION_AGREGAR_REGISTRO, "Agregar Registro");
        this.navItems = opciones;
      } else {
        this.quitarOpcion(opciones, 'Dashboard');
        this.quitarOpcion(opciones, this.constantes.OPCION_AGREGAR_REGISTRO);
        this.quitarOpcion(opciones, 'Generar reporte');
        this.quitarOpcion(opciones, 'Centro de alertas');
        this.navItems = opciones;
      }
    }else{
      this.navItems.push({'faIcon': 'fas fa-home','label': "Dashboard",'link': '/dashboard/lac'});
      this.navItems.push({'faIcon': 'fas fa-lightbulb','label': "¿Qué es la PNLOTI al 2040?",'link': 'consulta/l1'});
      this.navItems.push({'faIcon': 'fas fa-question-circle','label': "¿Por qué es importante la PNLOTI al 2040?",'link': 'consulta/l2'});
      this.navItems.push({'faIcon': 'fas fa-search','label': "¿Cuál es el problema público que busca solucionar la PNLOTI al 2040?",'link': 'consulta/l3'});
      this.navItems.push({'faIcon': 'fas fa-trophy','label': "¿Cuáles son los objetivos prioritarios de la PNLOTI al 2040?",'link': 'consulta/l4'});
      this.navItems.push({'faIcon': 'fas fa-clock','label': "¿Cuál es el horizonte temporal de la PNLOTI?",'link': 'consulta/l5'});
      this.navItems.push({'faIcon': 'fas fa-cog','label': "¿Cuántos servicios brinda la PNLOTI?",'link': 'consulta/l6'});
      this.navItems.push({'faIcon': 'fas fa-user-friends','label': "¿A quiénes beneficiará la actualización de la PNLOTI al 2040?",'link': 'consulta/l7'});
      this.navItems.push({'faIcon': 'fas fa-download','label': "DESCARGAR AQUÍ",'link': 'consulta/l8'});
      // this.navItems.push({'faIcon': 'fab fa-microsoft','label': "Dashboard",'link': '/dashboard/lac'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "¿Qué es la PNLOTI al 2040?",'link': 'consulta/l1'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "¿Por qué es importante la PNLOTI al 2040?",'link': 'consulta/l2'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "¿Cuál es el problema público que busca solucionar la PNLOTI al 2040?",'link': 'consulta/l3'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "¿Cuáles son los objetivos prioritarios de la PNLOTI al 2040?",'link': 'consulta/l4'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "¿Cuál es el horizonte temporal de la PNLOTI?",'link': 'consulta/l5'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "¿Cuántos servicios brinda la PNLOTI?",'link': 'consulta/l6'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "¿A quiénes beneficiará la actualización de la PNLOTI al 2040?",'link': 'consulta/l7'});
      // this.navItems.push({'faIcon': 'fas fa-check','label': "DESCARGAR AQUÍ",'link': 'consulta/l8'});
    }
    }, 2000);
  }

  public abrirMisDatos() {
    this.sharedService.userSession.soloLectura=true;
    this.dialog.open(UsuarioFormComponent, {
      data: this.sharedService.userSession,
      width: "500px",
      disableClose: true
    });
  }

  public abrirCambiarClave() {
    this.dialog.open(CambiarClaveDialogComponent, {
      width: "500px",
      disableClose: true
    });
  }

  private cambiarLabelOpcion(opciones: any[], label: string, newLabel: string) {
    let opcion = opciones.find(opc => opc.label == label);
    if (opcion) {
      opcion.label = newLabel;
    } else {
      opciones.forEach(opc => {
        if (opc.items)
          this.cambiarLabelOpcion(opc.items, label, newLabel);
      });
    }
  }

  public abrirObjetivoDialog(configPlan: ConfiguracionPlanBean) {

    let confPlanList = this.sharedService.planSession.listaConfiguracionPlan;
    if (configPlan.id != confPlanList[confPlanList.length - 1].id) {
      let objetivo = new ObjetivoBean();
      objetivo.configuracionPlan = configPlan;
      objetivo.abrirDesdeMenu = true;
      let dialogRef = this.dialog.open(ObjetivoDialogComponent, {
        data: objetivo,
        disableClose: true
      })

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.sharedService.abrirSidebarObjetivos = false;
          this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
            if (result.objetivoPadre) {
              this.router.navigate(["/objetivo/oc/", result.objetivoPadre.id], { skipLocationChange: true });
            } else {
              if(!(this.sharedService.userSession && this.sharedService.userSession.id)){
                this.router.navigate(["dashboard/lac"], { skipLocationChange: true });
              }else{
                this.router.navigate(["dashboard/lc"], { skipLocationChange: true });
              }
            }
          });
        }
      });
    } else {
      let meta = new MetaBean();
      meta.idPlan = this.sharedService.planSession.id;
      meta.nombreDinamico = confPlanList[confPlanList.length - 1].nombre;
      meta.configuracionPlan = configPlan;
      meta.abrirDesdeMenu = true;
      let dialogRef = this.dialog.open(MetaDialogComponent, {
        data: meta,
        width: "550px",
        disableClose: true
      })
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.sharedService.abrirSidebarObjetivos = false;
          if(result.esIndicadorPorObjetivo){
            this.router.navigateByUrl('', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/objetivo/oc/", result.objetivo.id], { skipLocationChange: true })
          );
          }else{
            this.router.navigateByUrl('', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/meta/mc/", result.objetivo.id], { skipLocationChange: true })
          );
          }

        }
      });
    }
  }

  public abrirAvanceDialog() {
    let avance = new AvanceBean();
    avance.abrirDesdeMenu = true;

    let dialogRef = this.dialog.open(AvanceDialogComponent, {
      data: avance,
      width: "550px",
      disableClose: true
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sharedService.abrirSidebarObjetivos = false;
        if(result.avance.esIndicadorPorObjetivo){
          this.router.navigateByUrl('', { skipLocationChange: true }).then(() =>
            this.router.navigate(["avance/ac", result.avance.meta.id, result.nombreMeta,result.avance.meta.objetivo.id], { skipLocationChange: true })
          );
        }else{
          this.router.navigateByUrl('', { skipLocationChange: true }).then(() =>
          this.router.navigate(["avance/ac", result.avance.meta.id, result.nombreMeta], { skipLocationChange: true })
        );
        }

      }
    });
  }

  private quitarOpcion(opciones: any[], label) {
    let index = opciones.findIndex(opc => opc.label == label);
    if (index > -1) {
      opciones.splice(index, 1);
    } else {
      opciones.forEach(opc => {
        if (opc.items)
          this.quitarOpcion(opc.items, label);
      });
    }
  }

  private agregarOpcion(opciones: any[], label: string, navItem: NavItem) {
    let index = opciones.findIndex(opc => opc.label == label);
    if (index > -1) {
      let opc = opciones[index];
      if (opc.items) {
        opc.items.push(navItem);
      } else {
        opc.items = [];
        opc.items.push(navItem);
      }
    } else {
      opciones.forEach(opc => {
        if (opc.items)
          this.agregarOpcion(opc.items, label, navItem);
      });
    }
  }

  public abrirSidebarObjetivos() {
    this.sharedService.abrirSidebarObjetivos = !this.sharedService.abrirSidebarObjetivos;
  }

}
